import Vue from 'vue'
import router from '../../router'

const state = {
	token: localStorage.getItem('user-token') || '',
	status: '',
	hasLoadedOnce: false
}

const getters = {
	isAuthenticated: state => !!state.token,

	authStatus: state => state.status,

	token: state => state.token
}

const actions = {
	AUTH_REQUEST: ({ commit, dispatch }, user) => {
		return new Promise((resolve, reject) => {
			commit('AUTH_REQUEST')
			Vue.axios({ url: 'login', data: user, method: 'POST' })
				.then(resp => {
					let data = resp.data.data

					commit('AUTH_SUCCESS', data)
					dispatch('USER_REQUEST')
					resolve(data)
				})
				.catch(err => {
					commit('AUTH_ERROR')
					localStorage.removeItem('user-token')
					reject(err)
				})
		})
	},

	AUTH_LOGOUT: ({ commit, dispatch }) => {
		return new Promise((resolve, reject) => {
			commit('AUTH_LOGOUT')
			localStorage.removeItem('user-token')
			Vue.axios.defaults.headers = {
				Authorization: ''
			}
			resolve()
		})
	}
}

const mutations = {
	AUTH_REQUEST: state => {
		state.status = 'loading'
	},

	AUTH_SUCCESS: (state, resp) => {
		state.status = 'success'
		localStorage.setItem('user-token', resp.token)
		Vue.axios.defaults.headers = {
			'Content-Type': 'application/json',
			Authorization: 'Bearer ' + resp.token
		}
		state.token = resp.token
		state.hasLoadedOnce = true
	},

	AUTH_ERROR: state => {
		state.status = 'error'
		state.hasLoadedOnce = true
	},

	AUTH_LOGOUT: state => {
		state.token = ''
		router.replace('/login')
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}
